import getAssetPath from '$utils/getAssetPath';

function getContextProp(context, name) {
	if (!context) return undefined;
	if (context[name] !== undefined) return context[name];
	if (context.node?.props?.[name] !== undefined) return context.node.props[name];
	if (context.attrs?.[name] !== undefined) return context.attrs[name];
	return undefined;
}

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
		icon: {
			type: String
		},
		customLabel: {
			type: String
		}
	},

	computed: {
		fieldOptions() {
			const options = getContextProp(this.context, 'options');
			return Array.isArray(options) ? options : [];
		},
		selectedValues() {
			const value = this.context._value ?? this.context.value ?? this.context.node?.value;
			return Array.isArray(value) ? value : [];
		},
	},

	methods: {
		getAssetPath,
		isChecked(val) {
			return this.selectedValues.includes(val);
		},
		toggle(val) {
			const next = [...this.selectedValues];
			const idx = next.indexOf(val);
			if (idx > -1) {
				next.splice(idx, 1);
			} else {
				next.push(val);
			}
			if (this.context.node && typeof this.context.node.input === 'function') {
				this.context.node.input(next);
			} else if (this.context.handlers && typeof this.context.handlers.input === 'function') {
				this.context.handlers.input(next);
			} else {
				this.context.model = next;
			}
		},
	},
};
